import { DLR_EXTRA_PRICES } from './currency';

// The DLR screening games sold as add-ons to a DLR plan (prices in USD, see DLR_EXTRA_PRICES)
export const DLR_GAMES = [
  { code: 'MIC', name: 'Instrument Coordination' },
  { code: 'SKT', name: 'Concentrativeness' },
  { code: 'ROT', name: 'Cube Rotation' },
  { code: 'OWT', name: 'Perceptual Speed' },
  { code: 'MEK', name: 'Visual Memory' },
  { code: 'RMS', name: 'Running Memory Span' },
  { code: 'PPT', name: 'Paper Folding' },
].map((g) => ({ ...g, price: DLR_EXTRA_PRICES[g.code] }));

export const extrasTotal = (selected) => DLR_GAMES.reduce((sum, g) => sum + (selected[g.code] ? g.price : 0), 0);
